<template>
  <div class="loader" role="status" aria-live="assertive" :aria-label="$t('loader.loading')">
    <LoaderBalls />
    <div v-if="rateLimitExceeded">
      <p class="info" v-html="$t('loader.rateLimitExceeded')"></p>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import LoaderBalls from '@/base/components/Loaders/LoaderBalls.vue'

export default {
  name: 'DefaultLoader',
  components: { LoaderBalls },
  computed: {
    ...mapState({
      rateLimitExceeded: state => state.payment.rateLimitExceeded
    })
  }
}
</script>
